import React from 'react';

const TYPE_STYLE = {
  LOGIN_SUCCESS: { color: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400', icon: 'login' },
  LOGIN_FAIL: { color: 'bg-red-50 text-red-500 dark:bg-red-500/10 dark:text-red-400', icon: 'alert' },
  FILE_UPLOAD: { color: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400', icon: 'upload' },
  FILE_DOWNLOAD: { color: 'bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400', icon: 'download' },
  FILE_DELETE: { color: 'bg-red-50 text-red-500 dark:bg-red-500/10 dark:text-red-400', icon: 'file' },
  OTP_SUCCESS: { color: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400', icon: 'shield' },
  OTP_FAIL: { color: 'bg-amber-50 text-amber-600 dark:bg-amber-500/10 dark:text-amber-400', icon: 'alert' },
  OTP_VERIFIED: { color: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-500/10 dark:text-indigo-400', icon: 'shield' },
  OTP_GENERATED: { color: 'bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400', icon: 'key' },
  ACCESS_REQUEST: { color: 'bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400', icon: 'users' },
  ACCESS_APPROVED: { color: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400', icon: 'check' },
  ACCESS_REJECTED: { color: 'bg-red-50 text-red-500 dark:bg-red-500/10 dark:text-red-400', icon: 'x' },
  REGISTER: { color: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-400', icon: 'user' },
};

const DEFAULT_STYLE = { color: 'bg-gray-100 text-gray-500 dark:bg-slate-700 dark:text-slate-400', icon: 'dot' };

const ICONS = {
  login: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>,
  upload: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>,
  download: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  shield: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>,
  key: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m21 2-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78Zm0 0L15.5 7.5m0 0 3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>,
  users: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  check: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 6 9 17l-5-5"/></svg>,
  x: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  user: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/></svg>,
  file: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  alert: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
  dot: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="4"/></svg>,
};

export function ActivityItem({ title, time, description, eventType }) {
  const ts = TYPE_STYLE[eventType] || DEFAULT_STYLE;
  return (
    <li
      className="
        user-dashboard-activity-item group flex items-start gap-3 rounded-xl px-3 py-3
        transition-all duration-200 ease-in-out
        hover:bg-gray-50 dark:hover:bg-slate-700/40
      "
    >
      <div className={`mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl transition-transform duration-200 group-hover:scale-105 ${ts.color}`}>
        {ICONS[ts.icon] || ICONS.dot}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-baseline justify-between gap-3">
          <span className="text-[13px] font-semibold text-gray-900 dark:text-slate-100">
            {title}
          </span>
          <span className="text-[11px] font-semibold text-gray-400 dark:text-slate-500">
            {time}
          </span>
        </div>
        {description && (
          <div className="mt-0.5 truncate text-[12px] font-medium leading-snug text-gray-500 dark:text-slate-400">
            {description}
          </div>
        )}
      </div>
    </li>
  );
}

export default ActivityItem;
